import { ReactNode, useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface ShareSettingsSectionProps {
  title: string;
  summary?: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
}

export default function ShareSettingsSection({
  title,
  summary,
  defaultOpen = false,
  children,
}: ShareSettingsSectionProps) {
  const [expanded, setExpanded] = useState(defaultOpen);

  return (
    <div className="p-[2px] rounded-xl bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8]">
      <div className="rounded-[10px] bg-white overflow-hidden">
        <button
          type="button"
          onClick={() => setExpanded((open) => !open)}
          aria-expanded={expanded}
          className="w-full min-h-[44px] px-5 py-4 flex items-center justify-between gap-3 bg-gray-50/50 hover:bg-gray-100/50 transition-colors text-left"
        >
          <span className="min-w-0">
            <span className="block font-medium text-gray-900">{title}</span>
            {summary && <span className="block text-xs text-gray-500 mt-0.5 truncate">{summary}</span>}
          </span>
          <span className="flex items-center gap-1 text-sm text-gray-500 shrink-0">
            {expanded ? "Hide" : "Show"}
            <ChevronDown className={cn("w-4 h-4 transition-transform duration-200", expanded && "rotate-180")} />
          </span>
        </button>
        {expanded && <div className="px-5 py-4 border-t space-y-4">{children}</div>}
      </div>
    </div>
  );
}
